import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  Box,
  Paper,
  Grid,
  TextField,
  Button,
  Card,
  CardContent,
  CardActions,
  Avatar,
  Chip,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tabs,
  Tab,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Snackbar,
  Alert,
  CircularProgress,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import SchoolIcon from "@mui/icons-material/School";
import SportsSoccerIcon from "@mui/icons-material/SportsSoccer";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import AddIcon from "@mui/icons-material/Add";
import NoteIcon from "@mui/icons-material/Note";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import EditIcon from "@mui/icons-material/Edit";
import api, { getCurrentMode } from "../../utils/api";
import { useAuth } from "../../context/AuthContext";

// Mock data for coaches
const MOCK_COACHES = [
  {
    id: 1,
    name: "John Smith",
    school: "Lincoln High School",
    city: "Portland",
    state: "OR",
    region: "Northwest",
    sport: "Football",
    position: "Head Coach",
    email: "jsmith@lincolnhs.edu",
    phone: "(503) 555-1234",
    yearsExperience: 15,
    championships: 2,
    avatar: "/assets/images/coach1.jpg",
    bio: "Coach Smith has led Lincoln High to 2 state championships in the last 5 years. He specializes in developing quarterbacks and runs a pro-style offense.",
    previousSchools: [
      {
        school: "Central High School",
        position: "Defensive Coordinator",
        years: "2010-2015",
        fromYear: 2010,
        toYear: 2015,
      },
      {
        school: "Riverside Academy",
        position: "Assistant Coach",
        years: "2008-2010",
        fromYear: 2008,
        toYear: 2010,
      },
    ],
    isFormerPlayer: true,
    playerYears: "2000-2004",
    playerFromYear: 2000,
    playerToYear: 2004,
    playerSchool: "University of Oregon",
    playerPosition: "Quarterback",
    notes: [],
  },
  {
    id: 2,
    name: "Michael Johnson",
    school: "Washington High School",
    city: "Seattle",
    state: "WA",
    region: "Northwest",
    sport: "Football",
    position: "Head Coach",
    email: "mjohnson@washingtonhs.edu",
    phone: "(206) 555-5678",
    yearsExperience: 12,
    championships: 1,
    avatar: "/assets/images/coach2.jpeg",
    bio: "Coach Johnson is known for his innovative spread offense and has sent multiple players to D1 programs in recent years.",
    previousSchools: [
      {
        school: "Eastside High School",
        position: "Offensive Coordinator",
        years: "2015-2018",
        fromYear: 2015,
        toYear: 2018,
      },
    ],
    isFormerPlayer: true,
    playerYears: "2005-2009",
    playerFromYear: 2005,
    playerToYear: 2009,
    playerSchool: "Washington State University",
    playerPosition: "Wide Receiver",
    notes: [],
  },
  {
    id: 3,
    name: "David Williams",
    school: "Jefferson High School",
    city: "Los Angeles",
    state: "CA",
    region: "West",
    sport: "Football",
    position: "Head Coach",
    email: "dwilliams@jeffersonhs.edu",
    phone: "(213) 555-9012",
    yearsExperience: 20,
    championships: 3,
    avatar: "/assets/images/coach3.jpeg",
    bio: "A veteran coach with over 20 years of experience, Coach Williams has developed numerous NFL players and runs a disciplined program focused on player development.",
    previousSchools: [
      {
        school: "Lincoln High School",
        position: "Head Coach",
        years: "2005-2015",
        fromYear: 2005,
        toYear: 2015,
      },
      {
        school: "Central Academy",
        position: "Assistant Coach",
        years: "2000-2005",
        fromYear: 2000,
        toYear: 2005,
      },
    ],
    isFormerPlayer: true,
    playerYears: "1990-1994",
    playerFromYear: 1990,
    playerToYear: 1994,
    playerSchool: "USC",
    playerPosition: "Linebacker",
    notes: [],
  },
  {
    id: 4,
    name: "James Brown",
    school: "Roosevelt High School",
    city: "Chicago",
    state: "IL",
    region: "Midwest",
    sport: "Football",
    position: "Head Coach",
    email: "jbrown@roosevelths.edu",
    phone: "(312) 555-3456",
    yearsExperience: 8,
    championships: 0,
    avatar: "/assets/images/coach4.jpeg",
    bio: "Coach Brown is a rising star in the Chicago area, known for his defensive schemes and ability to maximize player talent.",
    previousSchools: [],
    isFormerPlayer: false,
    playerYears: "",
    playerFromYear: "",
    playerToYear: "",
    playerSchool: "",
    playerPosition: "",
    notes: [],
  },
  {
    id: 5,
    name: "Robert Davis",
    school: "Kennedy High School",
    city: "Miami",
    state: "FL",
    region: "Southeast",
    sport: "Football",
    position: "Head Coach",
    email: "rdavis@kennedyhs.edu",
    phone: "(305) 555-7890",
    yearsExperience: 18,
    championships: 4,
    avatar: "/assets/images/coach5.jpg",
    bio: "One of the most successful coaches in Florida, Coach Davis runs a high-powered spread offense that regularly scores 40+ points per game.",
    notes: [],
  },
  {
    id: 6,
    name: "Sarah Miller",
    school: "Adams High School",
    city: "Atlanta",
    state: "GA",
    region: "Southeast",
    sport: "Football",
    position: "Offensive Coordinator",
    email: "smiller@adamshs.edu",
    phone: "(404) 555-2345",
    yearsExperience: 10,
    championships: 2,
    avatar: "/assets/images/coach6.jpg",
    bio: "Coach Miller is one of the top offensive minds in high school football, known for developing creative game plans tailored to player strengths.",
    notes: [],
  },
  {
    id: 7,
    name: "Chris Wilson",
    school: "Madison High School",
    city: "Dallas",
    state: "TX",
    region: "Southwest",
    sport: "Football",
    position: "Head Coach",
    email: "cwilson@madisonhs.edu",
    phone: "(214) 555-6789",
    yearsExperience: 25,
    championships: 5,
    avatar: "/assets/images/coach7.jpg",
    bio: "A Texas high school football legend, Coach Wilson has built a powerhouse program that regularly competes for state championships.",
    notes: [],
  },
  {
    id: 8,
    name: "Kevin Jones",
    school: "Monroe High School",
    city: "Phoenix",
    state: "AZ",
    region: "Southwest",
    sport: "Football",
    position: "Head Coach",
    email: "kjones@monroehs.edu",
    phone: "(602) 555-0123",
    yearsExperience: 14,
    championships: 1,
    avatar: "/assets/images/coach8.jpg",
    bio: "Coach Jones has transformed Monroe into a competitive program through innovative training methods and a strong emphasis on player academics.",
    notes: [],
  },
  {
    id: 9,
    name: "Thomas Moore",
    school: "Franklin High School",
    city: "Boston",
    state: "MA",
    region: "Northeast",
    sport: "Football",
    position: "Head Coach",
    email: "tmoore@franklinhs.edu",
    phone: "(617) 555-4567",
    yearsExperience: 16,
    championships: 2,
    avatar: "/assets/images/coach9.jpg",
    bio: "Coach Moore is known for his detailed preparation and ability to adapt his schemes to his players' strengths.",
    notes: [],
  },
  {
    id: 10,
    name: "Daniel Taylor",
    school: "Harrison High School",
    city: "Denver",
    state: "CO",
    region: "West",
    sport: "Football",
    position: "Head Coach",
    email: "dtaylor@harrisonhs.edu",
    phone: "(303) 555-8901",
    yearsExperience: 11,
    championships: 0,
    avatar: "/assets/images/coach10.jpg",
    bio: "Coach Taylor has built Harrison into a program known for its physicality and strong running game, adapting to the high altitude of Colorado.",
    notes: [],
  },
];

// Mock data for states
const STATES = [
  "AL",
  "AK",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "FL",
  "GA",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "OH",
  "OK",
  "OR",
  "PA",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VA",
  "WA",
  "WV",
  "WI",
  "WY",
];

// TabPanel component for tab content
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`coach-tabpanel-${index}`}
      aria-labelledby={`coach-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

const CoachDatabase = () => {
  const [coaches, setCoaches] = useState([]);
  const [filteredCoaches, setFilteredCoaches] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filters, setFilters] = useState({
    state: "",
    sport: "Football", // Default to Football
    championships: "",
    showStarredOnly: false,
  });
  const [isFilterDialogOpen, setIsFilterDialogOpen] = useState(false);
  const [selectedCoach, setSelectedCoach] = useState(null);
  const [isCoachDetailOpen, setIsCoachDetailOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [tabValue, setTabValue] = useState(0);
  const [sortBy, setSortBy] = useState("name");
  const [sortDirection, setSortDirection] = useState("asc");
  const [isAddingNote, setIsAddingNote] = useState(false);
  const [newNote, setNewNote] = useState("");
  const coachesPerPage = 6;

  // New state for add coach dialog
  const [isAddCoachDialogOpen, setIsAddCoachDialogOpen] = useState(false);
  const [newCoach, setNewCoach] = useState({
    firstName: "",
    lastName: "",
    school: "",
    city: "",
    state: "",
    sports: ["Football"],
    position: "",
    email: "",
    phone: "",
    championships: 0,
    previousSchools: [],
    isFormerPlayer: false,
    playerYears: "",
    playerFromYear: "",
    playerToYear: "",
    playerSchool: "",
    playerPosition: "",
    notes: [],
  });

  // New state for edit coach dialog
  const [isEditCoachDialogOpen, setIsEditCoachDialogOpen] = useState(false);
  const [editCoach, setEditCoach] = useState(null);

  // State for notifications and loading
  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);

  const [newPreviousSchool, setNewPreviousSchool] = useState({
    school: "",
    position: "",
    years: "",
    fromYear: "",
    toYear: "",
  });

  // New state for starred coaches
  const [starredCoaches, setStarredCoaches] = useState([]);
  const [starredCoachesLoading, setStarredCoachesLoading] = useState(false);

  // Get auth context
  const { user } = useAuth();

  // Fetch coaches from backend on component mount
  useEffect(() => {
    fetchCoaches();
  }, []);

  // Fetch starred coaches when user changes
  useEffect(() => {
    if (user) {
      fetchStarredCoaches();
    }
  }, [user]);

  // Fetch coaches from backend
  const fetchCoaches = async () => {
    setInitialLoading(true);
    try {
      if (getCurrentMode() === "sandbox") {
        // Sandbox mode - use mock data
        setCoaches(MOCK_COACHES);
        setFilteredCoaches(MOCK_COACHES);
      } else {
        const response = await api.coaches.getAll();

        let coachesData = [];
        if (response && response.success && response.data) {
          coachesData = response.data;
        } else if (Array.isArray(response)) {
          coachesData = response;
        } else {
          console.error("Invalid response format:", response);
          return;
        }

        const transformedCoaches = coachesData.map((coach) => ({
          ...coach,
          id: coach._id || coach.id, // Use _id if available, fallback to id
          _id: coach._id, // Keep the original _id for backend calls
          name: `${coach.firstName} ${coach.lastName}`.trim(),
          championships: coach.championships || 0,
          avatar: "/assets/images/default-avatar.jpg",
        }));

        setCoaches(transformedCoaches);
        setFilteredCoaches(transformedCoaches);
      }
    } catch (error) {
      console.error("Failed to fetch coaches:", error);
      // Fallback to mock data on error
      setCoaches(MOCK_COACHES);
      setFilteredCoaches(MOCK_COACHES);
    } finally {
      setInitialLoading(false);
    }
  };

  // Fetch starred coaches for the current user
  const fetchStarredCoaches = async () => {
    if (!user) {
      return;
    }

    setStarredCoachesLoading(true);
    try {
      const response = await api.coaches.getStarred();
      if (response && response.success && response.data) {
        // Transform the starred coaches to match the frontend format
        const transformedStarredCoaches = response.data.map((coach) => ({
          ...coach,
          id: coach._id || coach.id, // Use _id if available, fallback to id
          name: `${coach.firstName || ""} ${coach.lastName || ""}`.trim(),
        }));
        setStarredCoaches(transformedStarredCoaches);
      }
    } catch (error) {
      console.error("Failed to fetch starred coaches:", error);
    } finally {
      setStarredCoachesLoading(false);
    }
  };

  // Handle starring a coach
  const handleStarCoach = async (coachId) => {
    if (!user) {
      showNotification("Please login to star coaches", "warning");
      return;
    }

    try {
      // Use _id for backend calls, fallback to id for frontend
      const backendId = coaches.find((c) => c.id === coachId)?._id || coachId;
      const response = await api.coaches.star(backendId);
      if (response.success) {
        // Add coach to starred coaches
        const coach = coaches.find((c) => c.id === coachId);
        if (coach) {
          setStarredCoaches((prev) => [...prev, coach]);
        }
        showNotification("Coach starred successfully!");
      }
    } catch (error) {
      console.error("Failed to star coach:", error);
      showNotification("Failed to star coach", "error");
    }
  };

  // Handle unstarring a coach
  const handleUnstarCoach = async (coachId) => {
    if (!user) {
      showNotification("Please login to unstar coaches", "warning");
      return;
    }

    try {
      // Use _id for backend calls, fallback to id for frontend
      const backendId = coaches.find((c) => c.id === coachId)?._id || coachId;
      const response = await api.coaches.unstar(backendId);
      if (response.success) {
        // Remove coach from starred coaches
        setStarredCoaches((prev) => prev.filter((c) => c.id !== coachId));
        showNotification("Coach unstarred successfully!");
      }
    } catch (error) {
      console.error("Failed to unstar coach:", error);
      showNotification("Failed to unstar coach", "error");
    }
  };

  // Check if a coach is starred
  const isCoachStarred = (coachId) => {
    if (!coachId) return false;
    return starredCoaches.some(
      (coach) => coach.id === coachId || coach._id === coachId
    );
  };

  // Helper functions for notifications
  const showNotification = (message, severity = "success") => {
    setNotification({
      open: true,
      message,
      severity,
    });
  };

  const handleCloseNotification = () => {
    setNotification({ ...notification, open: false });
  };

  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  // Handle filter changes
  const handleFilterChange = (field, value) => {
    setFilters({
      ...filters,
      [field]: value,
    });
  };

  // Handle search submit
  const handleSearch = () => {
    applyFilters();
  };

  // Apply filters and search
  const applyFilters = () => {
    let results = [...coaches];

    // Apply search term
    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      results = results.filter((coach) => {
        const coachName = `${coach.firstName || ""} ${
          coach.lastName || ""
        }`.trim();
        return (
          coachName.toLowerCase().includes(term) ||
          coach.school.toLowerCase().includes(term) ||
          (coach.city && coach.city.toLowerCase().includes(term))
        );
      });
    }

    // Apply state filter
    if (filters.state) {
      results = results.filter((coach) => coach.state === filters.state);
    }

    // Apply sport filter
    if (filters.sport) {
      results = results.filter(
        (coach) => coach.sports && coach.sports.includes(filters.sport)
      );
    }

    // Apply championships filter
    if (filters.championships) {
      const minChampionships = parseInt(filters.championships);
      results = results.filter(
        (coach) => (coach.championships || 0) >= minChampionships
      );
    }

    // Apply starred filter
    if (filters.showStarredOnly && user) {
      results = results.filter((coach) => isCoachStarred(coach.id));
    }

    setFilteredCoaches(results);
    setPage(1); // Reset to first page when filters change
    setIsFilterDialogOpen(false);
  };

  // Clear all filters
  const handleClearFilters = () => {
    setFilters({
      state: "",
      sport: "Football",
      championships: "",
      showStarredOnly: false,
    });
    setSearchTerm("");
    setFilteredCoaches(coaches);
    setPage(1);
    setIsFilterDialogOpen(false);
  };

  // Handle opening coach detail
  const handleOpenCoachDetail = (coach) => {
    setSelectedCoach(coach);
    setIsCoachDetailOpen(true);
  };

  // Handle closing coach detail
  const handleCloseCoachDetail = () => {
    setIsCoachDetailOpen(false);
  };

  // Handle tab change
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  // Handle sorting
  const handleSort = (field) => {
    if (sortBy === field) {
      // Toggle direction if clicking the same field
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      // Set new field and default to ascending
      setSortBy(field);
      setSortDirection("asc");
    }
  };

  // Get sorted coaches
  const getSortedCoaches = (coaches) => {
    // First, separate starred and non-starred coaches
    const starredCoachesList = coaches.filter((coach) =>
      isCoachStarred(coach.id || coach._id)
    );
    const nonStarredCoaches = coaches.filter(
      (coach) => !isCoachStarred(coach.id || coach._id)
    );

    // Sort each group
    const sortCoaches = (coachesList) => {
      return [...coachesList].sort((a, b) => {
        let valueA, valueB;

        // Handle different field types
        switch (sortBy) {
          case "name":
            // Handle both old format (name) and new format (firstName + lastName)
            const nameA =
              a.name || `${a.firstName || ""} ${a.lastName || ""}`.trim();
            const nameB =
              b.name || `${b.firstName || ""} ${b.lastName || ""}`.trim();
            valueA = nameA.toLowerCase();
            valueB = nameB.toLowerCase();
            break;
          case "school":
            valueA = a.school.toLowerCase();
            valueB = b.school.toLowerCase();
            break;
          case "position":
            valueA = a.position.toLowerCase();
            valueB = b.position.toLowerCase();
            break;
          case "experience":
            valueA = a.yearsExperience || 0;
            valueB = b.yearsExperience || 0;
            break;
          case "championships":
            valueA = a.championships || 0;
            valueB = b.championships || 0;
            break;
          default:
            // Handle both old format (name) and new format (firstName + lastName)
            const defaultNameA =
              a.name || `${a.firstName || ""} ${a.lastName || ""}`.trim();
            const defaultNameB =
              b.name || `${b.firstName || ""} ${b.lastName || ""}`.trim();
            valueA = defaultNameA.toLowerCase();
            valueB = defaultNameB.toLowerCase();
        }

        // Sort based on direction
        if (sortDirection === "asc") {
          return valueA > valueB ? 1 : valueA < valueB ? -1 : 0;
        } else {
          return valueA < valueB ? 1 : valueA > valueB ? -1 : 0;
        }
      });
    };

    // Return starred coaches first, then non-starred coaches
    return [
      ...sortCoaches(starredCoachesList),
      ...sortCoaches(nonStarredCoaches),
    ];
  };

  // Handle page change
  const handlePageChange = (event, value) => {
    setPage(value);
  };

  // Handle adding a new note
  const handleAddNote = () => {
    setIsAddingNote(true);
    setNewNote("");
  };

  // Handle saving a new note
  const handleSaveNote = () => {
    if (newNote.trim() === "") {
      return;
    }

    const updatedCoach = {
      ...selectedCoach,
      notes: [
        ...selectedCoach.notes,
        {
          text: newNote,
          date: new Date().toISOString(),
        },
      ],
    };

    // Update the coach in the coaches array
    const updatedCoaches = coaches.map((coach) =>
      coach.id === selectedCoach.id ? updatedCoach : coach
    );

    setCoaches(updatedCoaches);
    setFilteredCoaches((prevFiltered) =>
      prevFiltered.map((coach) =>
        coach.id === selectedCoach.id ? updatedCoach : coach
      )
    );
    setSelectedCoach(updatedCoach);
    setNewNote("");
    setIsAddingNote(false);
  };

  // Handle canceling adding a note
  const handleCancelAddNote = () => {
    setIsAddingNote(false);
    setNewNote("");
  };

  // Handle deleting a note
  const handleDeleteNote = (noteIndex) => {
    const updatedCoach = {
      ...selectedCoach,
      notes: selectedCoach.notes.filter((_, index) => index !== noteIndex),
    };

    // Update the coach in the coaches array
    const updatedCoaches = coaches.map((coach) =>
      coach.id === selectedCoach.id ? updatedCoach : coach
    );

    setCoaches(updatedCoaches);
    setFilteredCoaches((prevFiltered) =>
      prevFiltered.map((coach) =>
        coach.id === selectedCoach.id ? updatedCoach : coach
      )
    );
    setSelectedCoach(updatedCoach);
  };

  // Handle opening the add coach dialog
  const handleOpenAddCoachDialog = () => {
    setNewCoach({
      firstName: "",
      lastName: "",
      school: "",
      city: "",
      state: "",
      sport: "Football",
      position: "",
      email: "",
      phone: "",
      yearsExperience: 0,
      championships: 0,
      bio: "",
      previousSchools: [],
      isFormerPlayer: false,
      playerYears: "",
      playerFromYear: "",
      playerToYear: "",
      playerSchool: "",
      playerPosition: "",
      notes: [],
    });
    setIsAddCoachDialogOpen(true);
  };

  // Handle closing the add coach dialog
  const handleCloseAddCoachDialog = () => {
    setIsAddCoachDialogOpen(false);
  };

  // Handle input change for new coach form
  const handleNewCoachChange = (e) => {
    const { name, value } = e.target;
    setNewCoach({
      ...newCoach,
      [name]: value,
    });
  };

  const handleAddPreviousSchool = () => {
    if (newPreviousSchool.school && newPreviousSchool.position) {
      const previousSchool = {
        ...newPreviousSchool,
      };

      setNewCoach({
        ...newCoach,
        previousSchools: [...newCoach.previousSchools, previousSchool],
      });

      setNewPreviousSchool({
        school: "",
        position: "",
        years: "",
        fromYear: "",
        toYear: "",
      });
    }
  };

  const handleRemovePreviousSchool = (index) => {
    const updatedPreviousSchools = newCoach.previousSchools.filter(
      (_, i) => i !== index
    );
    setNewCoach({
      ...newCoach,
      previousSchools: updatedPreviousSchools,
    });
  };

  const handlePreviousSchoolChange = (field, value) => {
    setNewPreviousSchool({
      ...newPreviousSchool,
      [field]: value,
    });
  };

  // Handle numeric input change for new coach form
  const handleNewCoachNumericChange = (e) => {
    const { name, value } = e.target;
    setNewCoach({
      ...newCoach,
      [name]: parseInt(value) || 0,
    });
  };

  // Handle adding a new coach
  const handleAddCoach = async () => {
    // Validate required fields
    if (
      !newCoach.firstName ||
      !newCoach.lastName ||
      !newCoach.school ||
      !newCoach.position
    ) {
      showNotification("Please fill in all required fields", "error");
      return;
    }

    setLoading(true);

    try {
      if (getCurrentMode() === "sandbox") {
        // Sandbox mode - use mock data
        const newCoachWithId = {
          ...newCoach,
          name: `${newCoach.firstName} ${newCoach.lastName}`.trim(), // Combine for display
          id: Date.now(),
          avatar: "/assets/images/default-avatar.jpg",
        };

        // Add to coaches array
        const updatedCoaches = [...coaches, newCoachWithId];
        setCoaches(updatedCoaches);

        // Add to filtered coaches if it matches current filters
        setFilteredCoaches((prevFiltered) => {
          let matchesFilters = true;

          if (filters.state && newCoachWithId.state !== filters.state) {
            matchesFilters = false;
          }

          if (filters.sport && newCoachWithId.sport !== filters.sport) {
            matchesFilters = false;
          }

          if (
            filters.championships &&
            newCoachWithId.championships < parseInt(filters.championships)
          ) {
            matchesFilters = false;
          }

          return matchesFilters
            ? [...prevFiltered, newCoachWithId]
            : prevFiltered;
        });

        // Add activity for new coach
        const newActivity = {
          id: Date.now(),
          coachId: newCoachWithId.id,
          coachName: newCoachWithId.name,
          newSchool: newCoachWithId.school,
          date: new Date().toISOString(),
          description: `Joined ${newCoachWithId.school} as ${newCoachWithId.position}`,
        };

        showNotification("Coach added successfully!");
      } else {
        // Development mode - use backend API
        const coachData = {
          firstName: newCoach.firstName,
          lastName: newCoach.lastName,
          school: newCoach.school,
          city: newCoach.city,
          state: newCoach.state,
          sports: [newCoach.sport],
          position: newCoach.position,
          email: newCoach.email,
          phone: newCoach.phone,
          previousSchools: newCoach.previousSchools,
          isFormerPlayer: newCoach.isFormerPlayer,
          playerYears: newCoach.playerYears,
          playerFromYear: newCoach.playerFromYear,
          playerToYear: newCoach.playerToYear,
          playerSchool: newCoach.playerSchool,
          playerPosition: newCoach.playerPosition,
        };

        const response = await api.coaches.create(coachData);

        // Add the new coach to the local state
        const newCoachWithId = {
          ...newCoach,
          id: response._id || response.id,
          avatar: "/assets/images/default-avatar.jpg",
        };

        const updatedCoaches = [...coaches, newCoachWithId];
        setCoaches(updatedCoaches);

        // Update filtered coaches
        setFilteredCoaches((prevFiltered) => {
          let matchesFilters = true;

          if (filters.state && newCoachWithId.state !== filters.state) {
            matchesFilters = false;
          }

          if (filters.sport && newCoachWithId.sport !== filters.sport) {
            matchesFilters = false;
          }

          if (
            filters.championships &&
            newCoachWithId.championships < parseInt(filters.championships)
          ) {
            matchesFilters = false;
          }

          return matchesFilters
            ? [...prevFiltered, newCoachWithId]
            : prevFiltered;
        });

        // Add activity for new coach
        const newActivity = {
          id: Date.now(),
          coachId: newCoachWithId.id,
          coachName: newCoachWithId.name,
          newSchool: newCoachWithId.school,
          date: new Date().toISOString(),
          description: `Joined ${newCoachWithId.school} as ${newCoachWithId.position}`,
        };

        // setCoachActivities([newActivity, ...coachActivities]);
        showNotification("Coach added successfully!");
      }

      setIsAddCoachDialogOpen(false);
    } catch (error) {
      console.error("Error adding coach:", error);
      showNotification(
        error.response?.data?.error || "Failed to add coach. Please try again.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  // Handle opening the edit coach dialog
  const handleOpenEditCoachDialog = () => {
    if (!selectedCoach) return;

    // Handle both old format (name) and new format (firstName + lastName)
    let firstName = "";
    let lastName = "";

    if (selectedCoach.firstName && selectedCoach.lastName) {
      // New format - use firstName and lastName directly
      firstName = selectedCoach.firstName;
      lastName = selectedCoach.lastName;
    } else if (selectedCoach.name) {
      const nameParts = selectedCoach.name.split(" ");
      firstName = nameParts[0] || "";
      lastName = nameParts.slice(1).join(" ") || "";
    }

    setEditCoach({
      ...selectedCoach,
      firstName,
      lastName,
      previousSchools: selectedCoach.previousSchools || [],
      isFormerPlayer: selectedCoach.isFormerPlayer || false,
      playerYears: selectedCoach.playerYears || "",
      playerFromYear: selectedCoach.playerFromYear || "",
      playerToYear: selectedCoach.playerToYear || "",
      playerSchool: selectedCoach.playerSchool || "",
      playerPosition: selectedCoach.playerPosition || "",
    });
    setIsEditCoachDialogOpen(true);
  };

  // Handle closing the edit coach dialog
  const handleCloseEditCoachDialog = () => {
    setIsEditCoachDialogOpen(false);
  };

  // Handle input change for edit coach form
  const handleEditCoachChange = (e) => {
    const { name, value } = e.target;
    setEditCoach({
      ...editCoach,
      [name]: value,
    });
  };

  // Handle numeric input change for edit coach form
  const handleEditCoachNumericChange = (e) => {
    const { name, value } = e.target;
    setEditCoach({
      ...editCoach,
      [name]: parseInt(value) || 0,
    });
  };

  // Handle saving edited coach
  const handleSaveEditedCoach = async () => {
    // Validate required fields
    if (
      !editCoach.firstName ||
      !editCoach.lastName ||
      !editCoach.school ||
      !editCoach.position
    ) {
      showNotification("Please fill in all required fields", "error");
      return;
    }

    setLoading(true);

    try {
      // Check if school has changed
      const schoolChanged = selectedCoach.school !== editCoach.school;

      // Combine firstName and lastName back into name for display
      const updatedEditCoach = {
        ...editCoach,
        name: `${editCoach.firstName} ${editCoach.lastName}`.trim(),
      };

      if (getCurrentMode() === "sandbox") {
        // Sandbox mode - use mock data

        // Update the coach in the coaches array
        const updatedCoaches = coaches.map((coach) =>
          coach.id === editCoach.id ? updatedEditCoach : coach
        );

        setCoaches(updatedCoaches);
        setFilteredCoaches((prevFiltered) =>
          prevFiltered.map((coach) =>
            coach.id === editCoach.id ? updatedEditCoach : coach
          )
        );

        // If school changed, add an activity
        if (schoolChanged) {
          const newActivity = {
            id: Date.now(),
            coachId: editCoach.id,
            coachName: updatedEditCoach.name,
            previousSchool: selectedCoach.school,
            newSchool: editCoach.school,
            date: new Date().toISOString(),
            description: `Moved from ${selectedCoach.school} to ${editCoach.school} as ${editCoach.position}`,
          };

          // setCoachActivities([newActivity, ...coachActivities]);
        }

        setSelectedCoach(updatedEditCoach);
        showNotification("Coach updated successfully!");
      } else {
        // Development mode - use backend API
        const coachData = {
          firstName: editCoach.firstName,
          lastName: editCoach.lastName,
          school: editCoach.school,
          city: editCoach.city,
          state: editCoach.state,
          sports: editCoach.sports || [editCoach.sport],
          position: editCoach.position,
          email: editCoach.email,
          phone: editCoach.phone,
          yearsExperience: editCoach.yearsExperience,
          championships: editCoach.championships,
          bio: editCoach.bio,
          previousSchools: editCoach.previousSchools,
          isFormerPlayer: editCoach.isFormerPlayer,
          playerYears: editCoach.playerYears,
          playerFromYear: editCoach.playerFromYear,
          playerToYear: editCoach.playerToYear,
          playerSchool: editCoach.playerSchool,
          playerPosition: editCoach.playerPosition,
        };

        // Use _id for backend calls, fallback to id for frontend
        const backendId = editCoach._id || editCoach.id;
        const response = await api.coaches.update(backendId, coachData);

        if (response && response.success) {
          // Update local state with the response from backend
          const updatedCoachFromBackend = {
            ...updatedEditCoach,
            ...response.data,
            id: response.data._id || response.data.id,
            _id: response.data._id,
            name: `${response.data.firstName} ${response.data.lastName}`.trim(),
          };

          // Update the coach in the coaches array
          const updatedCoaches = coaches.map((coach) =>
            coach.id === editCoach.id || coach._id === backendId
              ? updatedCoachFromBackend
              : coach
          );

          setCoaches(updatedCoaches);
          setFilteredCoaches((prevFiltered) =>
            prevFiltered.map((coach) =>
              coach.id === editCoach.id || coach._id === backendId
                ? updatedCoachFromBackend
                : coach
            )
          );

          // If school changed, add an activity
          if (schoolChanged) {
            const newActivity = {
              id: Date.now(),
              coachId: updatedCoachFromBackend.id,
              coachName: updatedCoachFromBackend.name,
              previousSchool: selectedCoach.school,
              newSchool: editCoach.school,
              date: new Date().toISOString(),
              description: `Moved from ${selectedCoach.school} to ${editCoach.school} as ${editCoach.position}`,
            };

            // setCoachActivities([newActivity, ...coachActivities]);
          }

          setSelectedCoach(updatedCoachFromBackend);
          showNotification("Coach updated successfully!");
        } else {
          throw new Error("Invalid response from server");
        }
      }

      setIsEditCoachDialogOpen(false);
    } catch (error) {
      console.error("Error updating coach:", error);
      showNotification(
        error.response?.data?.error ||
          "Failed to update coach. Please try again.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  // Get current coaches for pagination (page is 1-based)
  const indexOfLastCoach = page * coachesPerPage;
  const indexOfFirstCoach = indexOfLastCoach - coachesPerPage;
  const sortedCoaches = getSortedCoaches(filteredCoaches);
  const currentCoaches = sortedCoaches.slice(
    indexOfFirstCoach,
    indexOfLastCoach
  );

  // Render coach cards
  const renderCoachCards = () => {
    if (!currentCoaches || currentCoaches.length === 0) {
      return (
        <Grid item xs={12}>
          <Box sx={{ textAlign: "center", py: 4 }}>
            <Typography variant="body1" color="text.secondary">
              No coaches found. Total coaches: {coaches.length}, Filtered:{" "}
              {filteredCoaches.length}
            </Typography>
          </Box>
        </Grid>
      );
    }

    return currentCoaches.map((coach) => (
      <Grid item xs={12} sm={6} md={4} key={coach.id}>
        <Card
          sx={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            cursor: "pointer",
            "&:hover": {
              boxShadow: 6,
            },
            position: "relative",
            bgcolor: isCoachStarred(coach.id)
              ? "warning.50"
              : "background.paper",
            border: isCoachStarred(coach.id) ? "2px solid" : "1px solid",
            borderColor: isCoachStarred(coach.id) ? "warning.main" : "divider",
          }}
          onClick={() => handleOpenCoachDetail(coach)}
        >
          {/* Starred indicator badge */}
          {isCoachStarred(coach.id) && (
            <Box
              sx={{
                position: "absolute",
                top: 8,
                right: 8,
                zIndex: 1,
                bgcolor: "warning.main",
                color: "white",
                borderRadius: "50%",
                width: 32,
                height: 32,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: 2,
              }}
            >
              <StarIcon sx={{ fontSize: "1.2rem" }} />
            </Box>
          )}
          <CardContent sx={{ flexGrow: 1, pt: 2 }}>
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Avatar
                  src={coach.avatar}
                  sx={{ width: 56, height: 56, mr: 2 }}
                >
                  <PersonIcon />
                </Avatar>
                <Box sx={{ flexGrow: 1 }}>
                  <Typography
                    variant="h6"
                    component="div"
                    sx={{ lineHeight: 1.2 }}
                  >
                    {coach.name ||
                      `${coach.firstName || ""} ${coach.lastName || ""}`.trim()}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {coach.position}
                  </Typography>
                </Box>
              </Box>
            </Box>

            <Typography variant="body2" sx={{ mb: 1 }}>
              <SchoolIcon
                fontSize="small"
                sx={{ verticalAlign: "middle", mr: 1 }}
              />
              {coach.school}
            </Typography>

            <Typography variant="body2" sx={{ mb: 1 }}>
              <LocationOnIcon
                fontSize="small"
                sx={{ verticalAlign: "middle", mr: 1 }}
              />
              {coach.city}, {coach.state}
            </Typography>

            <Box sx={{ mt: 2 }}>
              {coach.sports && coach.sports.length > 0 && (
                <Chip
                  icon={<SportsSoccerIcon />}
                  label={coach.sports[0]}
                  size="small"
                  sx={{ mr: 1, mb: 1 }}
                />
              )}
              {coach.championships > 0 && (
                <Chip
                  icon={<StarIcon />}
                  label={`${coach.championships} Championship${
                    coach.championships > 1 ? "s" : ""
                  }`}
                  size="small"
                  color="primary"
                  sx={{ mb: 1 }}
                />
              )}
            </Box>
          </CardContent>
          <CardActions>
            <Button size="small" color="primary">
              View Profile
            </Button>
          </CardActions>
        </Card>
      </Grid>
    ));
  };

  // Render coach list items
  const renderCoachList = () => {
    const sortedCoaches = getSortedCoaches(filteredCoaches);
    const indexOfLastCoach = page * rowsPerPage;
    const indexOfFirstCoach = indexOfLastCoach - rowsPerPage;
    const currentSortedCoaches = sortedCoaches.slice(
      indexOfFirstCoach,
      indexOfLastCoach
    );

    // Get sort direction icon
    const getSortIcon = (field) => {
      if (sortBy === field) {
        return sortDirection === "asc" ? " ↑" : " ↓";
      }
      return "";
    };

    return (
      <>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell
                  onClick={() => handleSort("name")}
                  sx={{ cursor: "pointer", fontWeight: "bold" }}
                >
                  Name{getSortIcon("name")}
                </TableCell>
                <TableCell
                  onClick={() => handleSort("position")}
                  sx={{ cursor: "pointer", fontWeight: "bold" }}
                >
                  Position{getSortIcon("position")}
                </TableCell>
                <TableCell
                  onClick={() => handleSort("school")}
                  sx={{ cursor: "pointer", fontWeight: "bold" }}
                >
                  School{getSortIcon("school")}
                </TableCell>
                <TableCell>Location</TableCell>
                <TableCell
                  onClick={() => handleSort("experience")}
                  sx={{ cursor: "pointer", fontWeight: "bold" }}
                  align="center"
                >
                  Experience{getSortIcon("experience")}
                </TableCell>
                <TableCell
                  onClick={() => handleSort("championships")}
                  sx={{ cursor: "pointer", fontWeight: "bold" }}
                  align="center"
                >
                  Championships{getSortIcon("championships")}
                </TableCell>
                <TableCell align="center">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {currentSortedCoaches.map((coach) => (
                <TableRow
                  key={coach.id}
                  hover
                  onClick={() => handleOpenCoachDetail(coach)}
                  sx={{ cursor: "pointer" }}
                >
                  <TableCell>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Avatar
                        src={coach.avatar}
                        sx={{ mr: 2, width: 40, height: 40 }}
                      >
                        <PersonIcon />
                      </Avatar>
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        {coach.name ||
                          `${coach.firstName || ""} ${
                            coach.lastName || ""
                          }`.trim()}
                        {isCoachStarred(coach.id) && (
                          <StarIcon
                            sx={{ color: "warning.main", fontSize: "1rem" }}
                          />
                        )}
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell>{coach.position}</TableCell>
                  <TableCell>{coach.school}</TableCell>
                  <TableCell>{`${coach.city}, ${coach.state}`}</TableCell>
                  <TableCell align="center">
                    {coach.yearsExperience} years
                  </TableCell>
                  <TableCell align="center">
                    {coach.championships > 0 ? (
                      <Chip
                        label={`${coach.championships} ${
                          coach.championships > 1
                            ? "Championships"
                            : "Championship"
                        }`}
                        color="success"
                        size="small"
                      />
                    ) : (
                      "-"
                    )}
                  </TableCell>
                  <TableCell align="center">
                    <IconButton
                      onClick={(e) => {
                        e.stopPropagation();
                        if (isCoachStarred(coach.id)) {
                          handleUnstarCoach(coach.id);
                        } else {
                          handleStarCoach(coach.id);
                        }
                      }}
                      sx={{
                        color: isCoachStarred(coach.id)
                          ? "warning.main"
                          : "action.disabled",
                        "&:hover": {
                          color: isCoachStarred(coach.id)
                            ? "warning.dark"
                            : "action.active",
                        },
                      }}
                    >
                      {isCoachStarred(coach.id) ? (
                        <StarIcon />
                      ) : (
                        <StarBorderIcon />
                      )}
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={sortedCoaches.length}
          page={page - 1}
          onPageChange={(e, newPage) => setPage(newPage + 1)}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={(e) => {
            setRowsPerPage(parseInt(e.target.value, 10));
            setPage(1);
          }}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </>
    );
  };

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Box>
            <Typography variant="h4" component="h1" gutterBottom>
              High School Coach Database
            </Typography>
            {user && starredCoaches.length > 0 && (
              <Typography variant="body2" color="text.secondary">
                {starredCoaches.length} starred coach
                {starredCoaches.length !== 1 ? "es" : ""}
              </Typography>
            )}
          </Box>
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={handleOpenAddCoachDialog}
          >
            Add Coach
          </Button>
        </Box>

        <Box sx={{ mb: 3 }}>
          <TextField
            fullWidth
            placeholder="Search by coach name, or school"
            variant="outlined"
            value={searchTerm}
            onChange={handleSearchChange}
            onKeyPress={(e) => e.key === "Enter" && handleSearch()}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Box>

        <Divider sx={{ mb: 2 }} />

        <Box sx={{ width: "100%" }}>
          {initialLoading ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
              <CircularProgress size={40} />
            </Box>
          ) : (
            <>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                  value={tabValue}
                  onChange={handleTabChange}
                  aria-label="coach view tabs"
                >
                  <Tab label="Card View" />
                  <Tab label="List View" />
                </Tabs>
              </Box>

              <TabPanel value={tabValue} index={0}>
                <Grid container spacing={3}>
                  {renderCoachCards()}
                </Grid>
              </TabPanel>

              <TabPanel value={tabValue} index={1}>
                {renderCoachList()}
              </TabPanel>
              <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
                <Pagination
                  count={Math.ceil(sortedCoaches.length / coachesPerPage)}
                  page={page}
                  onChange={handlePageChange}
                  color="primary"
                  showFirstButton
                  showLastButton
                />
              </Box>
            </>
          )}
        </Box>
      </Paper>

      {/* Add Coach Dialog */}
      <Dialog
        open={isAddCoachDialogOpen}
        onClose={handleCloseAddCoachDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Add New Coach</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="First Name"
                name="firstName"
                value={newCoach.firstName}
                onChange={handleNewCoachChange}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Last Name"
                name="lastName"
                value={newCoach.lastName}
                onChange={handleNewCoachChange}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Position"
                name="position"
                value={newCoach.position}
                onChange={handleNewCoachChange}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="School"
                name="school"
                value={newCoach.school}
                onChange={handleNewCoachChange}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="City"
                name="city"
                value={newCoach.city}
                onChange={handleNewCoachChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel id="new-coach-state-label">State</InputLabel>
                <Select
                  labelId="new-coach-state-label"
                  name="state"
                  value={newCoach.state}
                  label="State"
                  onChange={handleNewCoachChange}
                >
                  {STATES.map((state) => (
                    <MenuItem key={state} value={state}>
                      {state}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel id="new-coach-sport-label">Sport</InputLabel>
                <Select
                  labelId="new-coach-sport-label"
                  name="sport"
                  value={newCoach.sport}
                  label="Sport"
                  onChange={handleNewCoachChange}
                >
                  <MenuItem value="Football">Football</MenuItem>
                  <MenuItem value="Basketball">Basketball</MenuItem>
                  <MenuItem value="Baseball">Baseball</MenuItem>
                  <MenuItem value="Soccer">Soccer</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Email"
                name="email"
                value={newCoach.email}
                onChange={handleNewCoachChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Phone"
                name="phone"
                value={newCoach.phone}
                onChange={handleNewCoachChange}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                fullWidth
                label="Years Experience"
                name="yearsExperience"
                type="number"
                value={newCoach.yearsExperience}
                onChange={handleNewCoachNumericChange}
                InputProps={{ inputProps: { min: 0 } }}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                fullWidth
                label="Championships"
                name="championships"
                type="number"
                value={newCoach.championships}
                onChange={handleNewCoachNumericChange}
                InputProps={{ inputProps: { min: 0 } }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Biography"
                name="bio"
                value={newCoach.bio}
                onChange={handleNewCoachChange}
                multiline
                rows={4}
              />
            </Grid>

            {/* Previous Schools Section */}
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom sx={{ mt: 2, mb: 1 }}>
                Previous Schools
              </Typography>

              {/* Display existing previous schools */}
              {newCoach.previousSchools.length > 0 && (
                <Box sx={{ mb: 2 }}>
                  {newCoach.previousSchools.map((prevSchool, index) => (
                    <Box
                      key={index}
                      sx={{
                        p: 1,
                        border: "1px solid",
                        borderColor: "divider",
                        borderRadius: 1,
                        mb: 1,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Box>
                        <Typography variant="body2" fontWeight="medium">
                          {prevSchool.school} - {prevSchool.position}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {prevSchool.years ||
                            `${prevSchool.fromYear}-${prevSchool.toYear}`}
                        </Typography>
                      </Box>
                      <Button
                        size="small"
                        color="error"
                        onClick={() => handleRemovePreviousSchool(index)}
                      >
                        Remove
                      </Button>
                    </Box>
                  ))}
                </Box>
              )}

              {/* Add new previous school form */}
              <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    fullWidth
                    size="small"
                    label="School Name"
                    value={newPreviousSchool.school}
                    onChange={(e) =>
                      handlePreviousSchoolChange("school", e.target.value)
                    }
                    placeholder="School name"
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Position"
                    value={newPreviousSchool.position}
                    onChange={(e) =>
                      handlePreviousSchoolChange("position", e.target.value)
                    }
                    placeholder="Position"
                  />
                </Grid>
                <Grid item xs={12} sm={3}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Years (e.g., 2010-2015)"
                    value={newPreviousSchool.years}
                    onChange={(e) =>
                      handlePreviousSchoolChange("years", e.target.value)
                    }
                    placeholder="Years"
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <Button
                    fullWidth
                    variant="outlined"
                    size="small"
                    onClick={handleAddPreviousSchool}
                    disabled={
                      !newPreviousSchool.school || !newPreviousSchool.position
                    }
                    sx={{ height: "40px" }}
                  >
                    Add
                  </Button>
                </Grid>
              </Grid>
            </Grid>

            {/* Former Player Section */}
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom sx={{ mt: 2, mb: 1 }}>
                Playing Background
              </Typography>

              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={3}>
                  <FormControl fullWidth>
                    <InputLabel id="former-player-label">
                      Former Player?
                    </InputLabel>
                    <Select
                      labelId="former-player-label"
                      name="isFormerPlayer"
                      value={newCoach.isFormerPlayer}
                      label="Former Player?"
                      onChange={(e) =>
                        setNewCoach({
                          ...newCoach,
                          isFormerPlayer: e.target.value,
                        })
                      }
                    >
                      <MenuItem value={false}>No</MenuItem>
                      <MenuItem value={true}>Yes</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                {newCoach.isFormerPlayer && (
                  <>
                    <Grid item xs={12} sm={3}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Years Played"
                        name="playerYears"
                        value={newCoach.playerYears}
                        onChange={handleNewCoachChange}
                        placeholder="e.g., 2000-2004"
                      />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <TextField
                        fullWidth
                        size="small"
                        label="School Attended"
                        name="playerSchool"
                        value={newCoach.playerSchool}
                        onChange={handleNewCoachChange}
                        placeholder="College/University"
                      />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Position Played"
                        name="playerPosition"
                        value={newCoach.playerPosition}
                        onChange={handleNewCoachChange}
                        placeholder="Position"
                      />
                    </Grid>
                  </>
                )}
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseAddCoachDialog}>Cancel</Button>
          <Button
            onClick={handleAddCoach}
            variant="contained"
            color="primary"
            startIcon={<SaveIcon />}
            disabled={loading}
          >
            {loading ? "Saving..." : "Save Coach"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Filter Dialog */}
      <Dialog
        open={isFilterDialogOpen}
        onClose={() => setIsFilterDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Filter Coaches</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel id="state-select-label">State</InputLabel>
                <Select
                  labelId="state-select-label"
                  value={filters.state}
                  label="State"
                  onChange={(e) => handleFilterChange("state", e.target.value)}
                >
                  <MenuItem value="">All States</MenuItem>
                  {STATES.map((state) => (
                    <MenuItem key={state} value={state}>
                      {state}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel id="sport-select-label">Sport</InputLabel>
                <Select
                  labelId="sport-select-label"
                  value={filters.sport}
                  label="Sport"
                  onChange={(e) => handleFilterChange("sport", e.target.value)}
                >
                  <MenuItem value="Football">Football</MenuItem>
                  <MenuItem value="Basketball">Basketball</MenuItem>
                  <MenuItem value="Baseball">Baseball</MenuItem>
                  <MenuItem value="Soccer">Soccer</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel id="championships-select-label">
                  Min. Championships
                </InputLabel>
                <Select
                  labelId="championships-select-label"
                  value={filters.championships}
                  label="Min. Championships"
                  onChange={(e) =>
                    handleFilterChange("championships", e.target.value)
                  }
                >
                  <MenuItem value="">Any</MenuItem>
                  <MenuItem value="1">At least 1</MenuItem>
                  <MenuItem value="2">At least 2</MenuItem>
                  <MenuItem value="3">At least 3</MenuItem>
                  <MenuItem value="4">At least 4</MenuItem>
                  <MenuItem value="5">At least 5</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            {user && (
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={filters.showStarredOnly}
                      onChange={(e) =>
                        handleFilterChange("showStarredOnly", e.target.checked)
                      }
                      color="primary"
                    />
                  }
                  label="Show only starred coaches"
                />
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClearFilters}>Clear Filters</Button>
          <Button onClick={() => setIsFilterDialogOpen(false)}>Cancel</Button>
          <Button onClick={applyFilters} variant="contained" color="primary">
            Apply Filters
          </Button>
        </DialogActions>
      </Dialog>

      {/* Edit Coach Dialog */}
      {editCoach && (
        <Dialog
          open={isEditCoachDialogOpen}
          onClose={handleCloseEditCoachDialog}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>Edit Coach</DialogTitle>
          <DialogContent>
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="First Name"
                  name="firstName"
                  value={editCoach.firstName}
                  onChange={handleEditCoachChange}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Last Name"
                  name="lastName"
                  value={editCoach.lastName}
                  onChange={handleEditCoachChange}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Position"
                  name="position"
                  value={editCoach.position}
                  onChange={handleEditCoachChange}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="School"
                  name="school"
                  value={editCoach.school}
                  onChange={handleEditCoachChange}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="City"
                  name="city"
                  value={editCoach.city}
                  onChange={handleEditCoachChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel id="edit-coach-state-label">State</InputLabel>
                  <Select
                    labelId="edit-coach-state-label"
                    name="state"
                    value={editCoach.state}
                    label="State"
                    onChange={handleEditCoachChange}
                  >
                    {STATES.map((state) => (
                      <MenuItem key={state} value={state}>
                        {state}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <FormControl fullWidth>
                  <InputLabel id="edit-coach-sport-label">Sport</InputLabel>
                  <Select
                    labelId="edit-coach-sport-label"
                    name="sport"
                    value={editCoach.sport}
                    label="Sport"
                    onChange={handleEditCoachChange}
                  >
                    <MenuItem value="Football">Football</MenuItem>
                    <MenuItem value="Basketball">Basketball</MenuItem>
                    <MenuItem value="Baseball">Baseball</MenuItem>
                    <MenuItem value="Soccer">Soccer</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Email"
                  name="email"
                  value={editCoach.email}
                  onChange={handleEditCoachChange}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Phone"
                  name="phone"
                  value={editCoach.phone}
                  onChange={handleEditCoachChange}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  label="Years Experience"
                  name="yearsExperience"
                  type="number"
                  value={editCoach.yearsExperience}
                  onChange={handleEditCoachNumericChange}
                  InputProps={{ inputProps: { min: 0 } }}
                />
              </Grid>
              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  label="Championships"
                  name="championships"
                  type="number"
                  value={editCoach.championships}
                  onChange={handleEditCoachNumericChange}
                  InputProps={{ inputProps: { min: 0 } }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Biography"
                  name="bio"
                  value={editCoach.bio}
                  onChange={handleEditCoachChange}
                  multiline
                  rows={4}
                />
              </Grid>

              {/* Previous Schools Section */}
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom sx={{ mt: 2, mb: 1 }}>
                  Previous Schools
                </Typography>

                {/* Display existing previous schools */}
                {editCoach.previousSchools &&
                  editCoach.previousSchools.length > 0 && (
                    <Box sx={{ mb: 2 }}>
                      {editCoach.previousSchools.map((prevSchool, index) => (
                        <Box
                          key={index}
                          sx={{
                            p: 1,
                            border: "1px solid",
                            borderColor: "divider",
                            borderRadius: 1,
                            mb: 1,
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <Box>
                            <Typography variant="body2" fontWeight="medium">
                              {prevSchool.school} - {prevSchool.position}
                            </Typography>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              {prevSchool.years ||
                                `${prevSchool.fromYear}-${prevSchool.toYear}`}
                            </Typography>
                          </Box>
                          <Button
                            size="small"
                            color="error"
                            onClick={() => {
                              const updatedPreviousSchools =
                                editCoach.previousSchools.filter(
                                  (_, i) => i !== index
                                );
                              setEditCoach({
                                ...editCoach,
                                previousSchools: updatedPreviousSchools,
                              });
                            }}
                          >
                            Remove
                          </Button>
                        </Box>
                      ))}
                    </Box>
                  )}

                {/* Add new previous school form */}
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      size="small"
                      label="School Name"
                      value={newPreviousSchool.school}
                      onChange={(e) =>
                        handlePreviousSchoolChange("school", e.target.value)
                      }
                      placeholder="School name"
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Position"
                      value={newPreviousSchool.position}
                      onChange={(e) =>
                        handlePreviousSchoolChange("position", e.target.value)
                      }
                      placeholder="Position"
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Years (e.g., 2010-2015)"
                      value={newPreviousSchool.years}
                      onChange={(e) =>
                        handlePreviousSchoolChange("years", e.target.value)
                      }
                      placeholder="Years"
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <Button
                      fullWidth
                      variant="outlined"
                      size="small"
                      onClick={() => {
                        if (
                          newPreviousSchool.school &&
                          newPreviousSchool.position
                        ) {
                          const previousSchool = {
                            ...newPreviousSchool,
                          };

                          setEditCoach({
                            ...editCoach,
                            previousSchools: [
                              ...(editCoach.previousSchools || []),
                              previousSchool,
                            ],
                          });

                          // Reset the form
                          setNewPreviousSchool({
                            school: "",
                            position: "",
                            years: "",
                            fromYear: "",
                            toYear: "",
                          });
                        }
                      }}
                      disabled={
                        !newPreviousSchool.school || !newPreviousSchool.position
                      }
                      sx={{ height: "40px" }}
                    >
                      Add
                    </Button>
                  </Grid>
                </Grid>
              </Grid>

              {/* Former Player Section */}
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom sx={{ mt: 2, mb: 1 }}>
                  Playing Background
                </Typography>

                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} sm={3}>
                    <FormControl fullWidth>
                      <InputLabel id="edit-former-player-label">
                        Former Player?
                      </InputLabel>
                      <Select
                        labelId="edit-former-player-label"
                        name="isFormerPlayer"
                        value={editCoach.isFormerPlayer || false}
                        label="Former Player?"
                        onChange={(e) =>
                          setEditCoach({
                            ...editCoach,
                            isFormerPlayer: e.target.value,
                          })
                        }
                      >
                        <MenuItem value={false}>No</MenuItem>
                        <MenuItem value={true}>Yes</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  {editCoach.isFormerPlayer && (
                    <>
                      <Grid item xs={12} sm={3}>
                        <TextField
                          fullWidth
                          size="small"
                          label="Years Played"
                          name="playerYears"
                          value={editCoach.playerYears || ""}
                          onChange={handleEditCoachChange}
                          placeholder="e.g., 2000-2004"
                        />
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <TextField
                          fullWidth
                          size="small"
                          label="School Attended"
                          name="playerSchool"
                          value={editCoach.playerSchool || ""}
                          onChange={handleEditCoachChange}
                          placeholder="College/University"
                        />
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <TextField
                          fullWidth
                          size="small"
                          label="Position Played"
                          name="playerPosition"
                          value={editCoach.playerPosition || ""}
                          onChange={handleEditCoachChange}
                          placeholder="Position"
                        />
                      </Grid>
                    </>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseEditCoachDialog}>Cancel</Button>
            <Button
              onClick={handleSaveEditedCoach}
              variant="contained"
              color="primary"
              startIcon={<SaveIcon />}
              disabled={loading}
            >
              {loading ? "Saving..." : "Save Changes"}
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Coach Detail Dialog */}
      {selectedCoach && (
        <Dialog
          open={isCoachDetailOpen}
          onClose={handleCloseCoachDetail}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Avatar
                  src={selectedCoach.avatar}
                  sx={{ width: 64, height: 64, mr: 2 }}
                >
                  <PersonIcon />
                </Avatar>
                <Box>
                  <Typography variant="h6">
                    {selectedCoach.name ||
                      `${selectedCoach.firstName || ""} ${
                        selectedCoach.lastName || ""
                      }`.trim()}
                  </Typography>
                  <Typography variant="subtitle2" color="text.secondary">
                    {selectedCoach.position} • {selectedCoach.sport}
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ display: "flex", gap: 1 }}>
                {user && (
                  <IconButton
                    onClick={() => {
                      if (isCoachStarred(selectedCoach.id)) {
                        handleUnstarCoach(selectedCoach.id);
                      } else {
                        handleStarCoach(selectedCoach.id);
                      }
                    }}
                    sx={{
                      color: isCoachStarred(selectedCoach.id)
                        ? "warning.main"
                        : "action.disabled",
                      "&:hover": {
                        color: isCoachStarred(selectedCoach.id)
                          ? "warning.dark"
                          : "action.active",
                      },
                    }}
                  >
                    {isCoachStarred(selectedCoach.id) ? (
                      <StarIcon />
                    ) : (
                      <StarBorderIcon />
                    )}
                  </IconButton>
                )}
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={handleOpenEditCoachDialog}
                  startIcon={<EditIcon />}
                >
                  Edit
                </Button>
              </Box>
            </Box>
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Typography variant="subtitle1" gutterBottom>
                  School Information
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <SchoolIcon
                    fontSize="small"
                    sx={{ verticalAlign: "middle", mr: 1 }}
                  />
                  {selectedCoach.school}
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <LocationOnIcon
                    fontSize="small"
                    sx={{ verticalAlign: "middle", mr: 1 }}
                  />
                  {selectedCoach.city}, {selectedCoach.state}
                </Typography>

                <Divider sx={{ my: 2 }} />

                <Typography variant="subtitle1" gutterBottom>
                  Contact Information
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <EmailIcon
                    fontSize="small"
                    sx={{ verticalAlign: "middle", mr: 1 }}
                  />
                  {selectedCoach.email}
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  <PhoneIcon
                    fontSize="small"
                    sx={{ verticalAlign: "middle", mr: 1 }}
                  />
                  {selectedCoach.phone}
                </Typography>
              </Grid>

              <Grid item xs={12} md={6}>
                <Typography variant="subtitle1" gutterBottom>
                  Coaching Experience
                </Typography>
                <Box sx={{ display: "flex", mb: 1 }}>
                  <Typography variant="body1" sx={{ mr: 2 }}>
                    <strong>Years Experience:</strong>{" "}
                    {selectedCoach.yearsExperience}
                  </Typography>
                  <Typography variant="body1">
                    <strong>Championships:</strong>{" "}
                    {selectedCoach.championships}
                  </Typography>
                </Box>

                <Divider sx={{ my: 2 }} />

                <Typography variant="subtitle1" gutterBottom>
                  Biography
                </Typography>
                <Typography variant="body2" paragraph>
                  {selectedCoach.bio}
                </Typography>

                {/* Previous Schools Section */}
                {selectedCoach.previousSchools &&
                  selectedCoach.previousSchools.length > 0 && (
                    <>
                      <Divider sx={{ my: 2 }} />
                      <Typography variant="subtitle1" gutterBottom>
                        Previous Schools
                      </Typography>
                      <Box sx={{ mb: 2 }}>
                        {selectedCoach.previousSchools.map(
                          (prevSchool, index) => (
                            <Box
                              key={index}
                              sx={{
                                p: 1,
                                border: "1px solid",
                                borderColor: "divider",
                                borderRadius: 1,
                                mb: 1,
                              }}
                            >
                              <Typography variant="body2" fontWeight="medium">
                                {prevSchool.school} - {prevSchool.position}
                              </Typography>
                              <Typography
                                variant="caption"
                                color="text.secondary"
                              >
                                {prevSchool.years ||
                                  `${prevSchool.fromYear}-${prevSchool.toYear}`}
                              </Typography>
                            </Box>
                          )
                        )}
                      </Box>
                    </>
                  )}

                {/* Playing Background Section */}
                {selectedCoach.isFormerPlayer && (
                  <>
                    <Divider sx={{ my: 2 }} />
                    <Typography variant="subtitle1" gutterBottom>
                      Playing Background
                    </Typography>
                    <Box sx={{ mb: 2 }}>
                      <Typography variant="body2" sx={{ mb: 0.5 }}>
                        <strong>School:</strong> {selectedCoach.playerSchool}
                      </Typography>
                      <Typography variant="body2" sx={{ mb: 0.5 }}>
                        <strong>Position:</strong>{" "}
                        {selectedCoach.playerPosition}
                      </Typography>
                      <Typography variant="body2" sx={{ mb: 0.5 }}>
                        <strong>Years:</strong> {selectedCoach.playerYears}
                      </Typography>
                    </Box>
                  </>
                )}

                <Divider sx={{ my: 2 }} />

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mb: 1,
                  }}
                >
                  <Typography variant="subtitle1" gutterBottom>
                    Notes
                  </Typography>
                  {!isAddingNote && (
                    <Button
                      startIcon={<AddIcon />}
                      size="small"
                      onClick={handleAddNote}
                    >
                      Add Note
                    </Button>
                  )}
                </Box>

                {isAddingNote ? (
                  <Box sx={{ mb: 2 }}>
                    <TextField
                      fullWidth
                      multiline
                      rows={3}
                      placeholder="Enter your note here..."
                      value={newNote}
                      onChange={(e) => setNewNote(e.target.value)}
                      variant="outlined"
                      size="small"
                      sx={{ mb: 1 }}
                    />
                    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                      <Button
                        size="small"
                        onClick={handleCancelAddNote}
                        sx={{ mr: 1 }}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="contained"
                        size="small"
                        startIcon={<SaveIcon />}
                        onClick={handleSaveNote}
                        disabled={newNote.trim() === ""}
                      >
                        Save
                      </Button>
                    </Box>
                  </Box>
                ) : (
                  <Box>
                    {selectedCoach.notes.length === 0 ? (
                      <Typography variant="body2" color="text.secondary">
                        No notes added yet.
                      </Typography>
                    ) : (
                      <List
                        dense
                        sx={{
                          bgcolor: "background.paper",
                          maxHeight: 200,
                          overflow: "auto",
                        }}
                      >
                        {selectedCoach.notes.map((note, index) => (
                          <ListItem
                            key={index}
                            secondaryAction={
                              <IconButton
                                edge="end"
                                aria-label="delete"
                                onClick={() => handleDeleteNote(index)}
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            }
                          >
                            <ListItemAvatar>
                              <Avatar
                                sx={{
                                  width: 24,
                                  height: 24,
                                  bgcolor: "primary.main",
                                }}
                              >
                                <NoteIcon fontSize="small" />
                              </Avatar>
                            </ListItemAvatar>
                            <ListItemText
                              primary={note.text}
                              secondary={new Date(
                                note.date
                              ).toLocaleDateString()}
                            />
                          </ListItem>
                        ))}
                      </List>
                    )}
                  </Box>
                )}
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseCoachDetail}>Close</Button>
          </DialogActions>
        </Dialog>
      )}

      {/* Notification Snackbar */}
      <Snackbar
        open={notification.open}
        autoHideDuration={6000}
        onClose={handleCloseNotification}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={handleCloseNotification}
          severity={notification.severity}
          sx={{ width: "100%" }}
        >
          {notification.message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default CoachDatabase;
